export interface ObservationType {
    id: string;
    code: string;
    title: string;
    description: string;
    chartDatasets: {
      label: string;
      code?: string;
      unit: string;
      backgroundColor: string;
      borderColor: string;
    }[];
  }
  
  const backgroundColor = 'rgba(0, 166, 81, 0.7)';
  const borderColor = 'rgba(0, 166, 81, 1)';
  const secondBackgroundColor = 'rgba(27, 117, 188, 0.7)';
  const secondBorderColor = 'rgba(27, 117, 188, 1)';
  
  export const measurementsMeta: Record<string, ObservationType> = {
    'Blood Pressure': {
      id: 'Blood Pressure',
      code: '85354-9',
      title: 'Blood Pressure',
      description:
        'Your blood pressure is the pressure exerted on the walls of your blood vessels. When this pressure is high, it can damage your blood vessels and increase your risk for a heart attack or stroke. We measure your blood pressure periodically to make sure it is not staying high. Hypertention is a condition that refers to consistantly high blood pressure.',
      chartDatasets: [
        {
          label: 'Diastolic',
          code: '8462-4',
          unit: 'mm[Hg]',
          backgroundColor: secondBackgroundColor,
          borderColor: secondBorderColor,
        },
        {
          label: 'Systolic',
          code: '8480-6',
          unit: 'mm[Hg]',
          backgroundColor,
          borderColor,
        },
      ],
    },
    'Body Temperature': {
      id: 'Body Temperature',
      code: '8310-5',
      title: 'Body Temperature',
      description: 'Your body temperature values',
      chartDatasets: [
        {
          label: 'Body Temperature',
          unit: 'C',
          backgroundColor,
          borderColor,
        },
      ],
    },
    'Steps': {
      id: 'Steps',
      code: '41950-7',
      title: 'Steps',
      description: 'Your Daily Steps values',
      chartDatasets: [
        {
          label: 'Steps',
          unit: 'Steps',
          backgroundColor,
          borderColor,
        },
      ],
    },
    'Blood Glucose': {
        id: 'blood-glucose',
        code: '2339-0',
        title: 'Blood Glucose',
        description: 'Your blood glucose values',
        chartDatasets: [
          {
            label: 'Blood Glucose',
            unit: 'mmol/L',
            backgroundColor,
            borderColor,
          },
        ],
      },
    'Height': {
      id: 'Height',
      code: '8302-2',
      title: 'Height',
      description: 'Your height values',
      chartDatasets: [
        {
          label: 'Height',
          unit: 'in',
          backgroundColor,
          borderColor,
        },
      ],
    },
    'SPO2': {
      id: 'SPO2',
      code: '59408-5',
      title: 'SP02',
      description: 'Your SPO2 values',
      chartDatasets: [
        {
          label: 'SPO2 Levels',
          unit: '%',
          backgroundColor,
          borderColor,
        },
      ],
    },
    'Body Fat': {
      id: 'Body Fat',
      code: '41982-0',
      title: 'Body Fat',
      description: 'Your Body Fat Percentage',
      chartDatasets: [
        {
          label: 'Body Fat Levels',
          unit: '%',
          backgroundColor,
          borderColor,
        },
      ],
    },
    'Heart Rate': {
      id: 'Heart Rate',
      code: '8867-4',
      title: 'Heart Rate',
      description: 'Your heart rate values',
      chartDatasets: [
        {
          label: 'Heart Rate',
          unit: 'beats/minute',
          backgroundColor,
          borderColor,
        },
      ],
    },
    Weight: {
      id: 'Weight',
      code: '29463-7',
      title: 'Weight',
      description: 'Your weight values',
      chartDatasets: [
        {
          label: 'Weight',
          unit: 'lbs',
          backgroundColor,
          borderColor,
        },
      ],
    },
    BMI: {
      id: 'BMI',
      code: '59576-9',
      title: 'BMI',
      description: 'Your Body Mass Index values',
      chartDatasets: [
        {
          label: 'kg/m2',
          unit: 'kg/m2',
          backgroundColor,
          borderColor,
        },
      ],
    },
    ECG: {
      id: 'ECG',
      code: '58261-9',
      title: 'ECG',
      description: 'Electrocardiogram Serial Reading',
      chartDatasets: [
        {
          label: 'mm/s',
          unit: 'mm/s',
          backgroundColor,
          borderColor,
        },
      ],
    },
    "Calories burned": {
      id: 'Calories burned',
      code: 'LP416428-3',
      title: 'ECG',
      description: 'Calories burned',
      chartDatasets: [
        {
          label: 'calorie',
          unit: 'calorie',
          backgroundColor,
          borderColor,
        },
      ],
    },
    "Cycling": {
      id: 'Cycling',
      code: '73985-4',
      title: 'Cycling',
      description: 'The distance moved by cycling.g',
      chartDatasets: [
        {
          label: 'meter',
          unit: 'meter',
          backgroundColor,
          borderColor,
        },
      ],
    },
    "Insulin Delivery": {
      id: 'Insulin Delivery',
      code: '20448-7',
      title: 'Insulin Delivery',
      description: 'Insulin Delivery',
      chartDatasets: [
        {
          label: 'Units/Volume',
          unit: 'Units/Volume',
          backgroundColor,
          borderColor,
        },
      ],
    },
  };
  